'use client';

import H2 from '@/components/typography/h2';
import P from '@/components/typography/p';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

export default function Article({
    localizationKey,
    hasImage = false,
}: {
    localizationKey: string;
    hasImage?: boolean;
}) {
    const { t } = useTranslation();

    const title = t(`${localizationKey}.title`);
    const hasTitle = title && title !== `${localizationKey}.title`;

    return (
        <>
            {/* Desktop view */}
            <div className="hidden xl:block">
                <div
                    className={cn(
                        'border-primary relative flex flex-col items-center justify-center gap-5 border-b px-6',
                        hasImage ? 'py-52' : 'py-25',
                    )}
                >
                    <div className="flex w-full gap-20 2xl:gap-3">
                        <div className="relative w-5/12">
                            <H2 className="ml-[10rem] w-[425px]">
                                {hasTitle ? (
                                    title
                                ) : (
                                    <>
                                        {t(`${localizationKey}.title1`)} &#215;{' '}
                                        <span className="italic">
                                            {t(
                                                `${localizationKey}.title2`,
                                            )}{' '}
                                        </span>
                                        &#215; {t(`${localizationKey}.title3`)}
                                    </>
                                )}
                            </H2>
                        </div>
                        <div className={`w-6/12`}>
                            <P
                                className="flex w-full max-w-3xl flex-col gap-3 whitespace-pre-line"
                                isHtml
                            >
                                {t(`${localizationKey}.text`)}
                            </P>
                        </div>
                    </div>
                    {hasImage && (
                        <Image
                            src="/images/about/coffe.png"
                            alt="About Us"
                            className="absolute right-[-4.5rem] bottom-[-7rem] z-10 h-[250px] w-auto max-w-full lg:bottom-[-17.5rem] lg:h-[530px]"
                            width={350}
                            height={350}
                        />
                    )}
                </div>
            </div>

            {/* Mobile view */}
            <div className="relative block xl:hidden">
                <div
                    className={cn(
                        'border-primary relative flex flex-col items-start justify-center gap-5 border-b px-6 py-[60px] pb-[3.5rem]',
                        hasImage ? 'h-screen pt-[6.5rem]' : '',
                    )}
                >
                    <H2 className="">
                        {hasTitle ? (
                            title
                        ) : (
                            <>
                                {t(`${localizationKey}.title1`)} &#215;{' '}
                                <span className="italic">
                                    {t(`${localizationKey}.title2`)}{' '}
                                </span>
                                &#215; {t(`${localizationKey}.title3`)}
                            </>
                        )}
                    </H2>
                    <div
                        className={cn(
                            hasImage ? 'mb-12 w-full lg:w-9/12' : 'w-full',
                        )}
                    >
                        <P className="flex w-full flex-col gap-3 whitespace-pre-line">
                            {t(`${localizationKey}.text`)}
                        </P>
                    </div>
                </div>
                {hasImage && (
                    <Image
                        src="/images/about/coffe.png"
                        alt="About Us"
                        className="absolute right-[0rem] bottom-[-7rem] z-10 h-[250px] w-auto max-w-full lg:right-[0rem] lg:bottom-[-17.5rem] lg:h-[530px]"
                        width={350}
                        height={350}
                    />
                )}
            </div>
        </>
    );
}
